

import backgroundThemePlaceholder from '../assets/images/background-theme-placeholder.webp'
import basicThemePlaceholder from '../assets/images/basic-theme-placeholder.webp'
import modernThemePlaceholder from '../assets/images/modern-theme-placeholder.webp'
import stylishThemePlaceholder from '../assets/images/stylish-theme-placeholder.webp'
import outlineThemePlaceholder from '../assets/images/outline-theme-placeholder.webp'
import previewThemePlaceholder from '../assets/images/preview-theme-placeholder.webp'
import mobileThemePlaceholder from '../assets/images/mobile-theme-placeholder.webp'


export const THEMES = [
    {
        label: 'background',
        preview: backgroundThemePlaceholder
    },
    {
        label: 'stylish',
        preview: stylishThemePlaceholder
    },
    {
        label: 'basic',
        preview: basicThemePlaceholder
    },
    {
        label: 'modern',
        preview: modernThemePlaceholder
    },
    {
        label: 'outline',
        preview: outlineThemePlaceholder
    },
    {
        label: 'preview',
        preview: previewThemePlaceholder
    },
    {
        label: 'mobile',
        preview: mobileThemePlaceholder
    },
]